import CallToActions from './call-to-actions';

export default CallToActions;
